<template>
  <TextSection message_id="welcome" :image_name='$layout.isMobile ? "w360.jpg" : "w1366.jpg"'>
    <div class="buttons" :class='$layout.isMobile ? "flex-column mobile":"flex-row"'>
      <BorderlessButton border="blue" href="/servers">{{$t("order")}}</BorderlessButton>
      <div v-if="$layout.isMobile" class="flex-row justify-content-center">
        <BorderlessButton href="/servers">Подобрать конфигурацию</BorderlessButton>
      </div>
      <BorderlessButton v-else href="/servers">Подобрать конфигурацию</BorderlessButton>
    </div>
  </TextSection>
</template>

<script>
import TextSection from "@/components/TextSection";
import BorderlessButton from "@/components/BorderlessButton";

export default {
  name: 'Welcome',
  components: {
    TextSection,
    BorderlessButton,
  },
}
</script>

<style lang="scss" scoped>
.buttons {
  gap: 40px;
}

.buttons.mobile {
  gap: 22px;
}
</style>
